module.exports = __webpack_public_path__ + "Intellectual-bc5f4bac56bc6a9c66e986f1b4023880.png";